export default {
  // registrationAddressUnrestricted_value:function(value){
  //   // if (value.length === 0) {
  //   //   return {code: 1, msg: 'Обязательное поле', ShowError: true};
  //   // } else {
  //   //   return {code: 0, msg: '', ShowError: false};
  //   //
  //   // }
  //   //
  //   // if(value.unrestricted_value === undefined || value.unrestricted_value.length === 0) {
  //   //   return {code: 1, msg: 'Обязательное поле, Вы должны выбрать адрес из выпадающего списка', ShowError: true};
  //   // }
  //   // if (value.unrestricted_value !== undefined && value.unrestricted_value !== state.client[target+'Unrestricted_value']) {
  //   //   return 'Вы должны выбрать адрес из выпадающего списка';
  //   // }
  //   // try {
  //   //   if (state.client[target].data.house == null) {
  //   //     return 'Адрес не полный, укажите город, улицу и номер дома';
  //   //   }
  //   // } catch (e) {
  //   //   return 'Адрес не корректный';
  //   // }
  //
  //
  //
  // },
  
  isEmpty: function (value) {
    if (value.length === 0) {
      return {code: 1, msg: 'Обязательное поле', ShowError: true};
    } else {
      return {code: 0, msg: '', ShowError: false};
    }
  },

}
